<app-userapi-shared-oauth [userApi]="userApi">
  <p translate="INCLUDE_MODALUSERAPI_LABEL_URL" [translateParams]="{ api: userApi.api.name }"></p>

  <div class="flex space-x-2 mb-2">
    @if (userApi.api.urlPrefix) {
      <div class="my-auto">{{ userApi.api.urlPrefix }}</div>
    }
    <div class="w-full">
      <input
          class="form-input"
          name="url"
          type="text"
          autofocus
          [(ngModel)]="userApi.url" [ngModelOptions]="{standalone: true}"
          [attr.placeholder]="userApi.api.url"/>
    </div>
    @if (userApi.api.urlPostfix) {
      <div class="my-auto">{{ userApi.api.urlPostfix }}</div>
    }
  </div>

  <p [innerHTML]="userApi.api.configDescription"></p>

  <label
      class="form-label"
      for="publicKey">Consumer Key</label>
  <input
      class="form-input"
      id="publicKey"
      name="publicKey"
      type="text"
      autofocus
      [(ngModel)]="userApi.publicKey" [ngModelOptions]="{standalone: true}"
      placeholder="Consumer Key"/>

  <label
      class="form-label"
      for="privateKey">Consumer Secret</label>
  <input
      class="form-input"
      id="privateKey"
      name="privateKey"
      type="text"
      [(ngModel)]="userApi.privateKey" [ngModelOptions]="{standalone: true}"
      placeholder="Consumer Secret"/>

</app-userapi-shared-oauth>
